import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { EDUCATION_LIST, EDUCATION_CHANGE_STATUS, EDUCATION_ADDEDIT, EDUCATION_DELETE } from "../../api/constApi";
import { EducationListApi, EducationChangeStatusApi, AddEditEducationApi, educationDeleteApi } from "../Services/educationService";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const educationList = createAsyncThunk(EDUCATION_LIST, async (payload) => {
    const response = await EducationListApi(payload);
    return response.data;
});

export const educationChangeStatus = createAsyncThunk(EDUCATION_CHANGE_STATUS, async (payload) => {
    const response = await EducationChangeStatusApi(payload);
    return response.data;
});

export const addEditEducation = createAsyncThunk(EDUCATION_ADDEDIT, async (payload) => {
    const response = await AddEditEducationApi(payload);
    return response.data;
});

export const deleteEducation = createAsyncThunk(EDUCATION_DELETE, async (payload) => {
    const response = await educationDeleteApi(payload);
    return response.data;
});

export const educationSlice = createSlice({
    name: "education",
    initialState: {
        education: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(educationList.fulfilled, (state, action) => {
            state.education = action?.payload;
        });
        builder.addCase(addEditEducation.fulfilled, (state, action) => {
            state.education = action?.payload?.Data;
          });
    }
});

export default educationSlice.reducer;

// villagelist selector
export const selectEducationList = (state) => state?.education?.education;
export const useEducationList = () => {
  const education = useSelector(selectEducationList);
  return useMemo(() => education, [education]);
};